/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import withIntegrationCardContext from 'hoc/withIntegrationCardContext';
import Slider from 'react-slick';

const Mixpanel = ({ sliderSettings }) => {
  const { img1, img2 } = useStaticQuery(graphql`
    query {
      img1: file(relativePath: { eq: "marketplace/mixpanel/1.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      img2: file(relativePath: { eq: "marketplace/mixpanel/2.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  const photos = [
    {
      img: img1.childImageSharp.fluid,
      alt: 'Mixpanel Integration',
      title: 'Integrate Mixpanel with LiveSession',
    },
    {
      img: img2.childImageSharp.fluid,
      alt: 'Mixpanel Integration',
      title: 'Integrate Mixpanel with LiveSession',
    },
  ];
  return (
    <>
      <Slider {...sliderSettings(photos)}>
        {photos.map(({ img, alt, title }) => (
          <div key={img}>
            <Img fluid={img} alt={alt} title={title} />
          </div>
        ))}
      </Slider>
      <div className="section">
        <h2>Overview</h2>
        <p>
          Mixpanel is a product analytics tool to help you learn more about your users, increase
          engagement, and boost conversions. LiveSession integration will help you get even more
          from it:
        </p>
      </div>
      <div className="section">
        <h2>Benefits</h2>
        <ul className="checkmarks">
          <li>Add a direct session recording link to Mixpanel </li>
          <li>Access all user data in one place</li>
          <li>Get more insights</li>
        </ul>
      </div>
      <h2>How to install</h2>
      <p>
        Just copy and paste a piece of code, as described in our{' '}
        <a href="/help/mixpanel-integration/">help center</a>.
      </p>
    </>
  );
};

export default withIntegrationCardContext(Mixpanel);

Mixpanel.propTypes = {
  sliderSettings: PropTypes.func.isRequired,
};
